// Copyright (c) 2016 Deere & Company

import actions from '../../action-list';

export const updateFailedModeDropDown = (key, collection) => ({
    collection,
    key,
    property: 'failureMode',
    type: actions.UPDATE_CLAIM_ATTACHMENT_FAILED_MODE
});

export const updateDownTimeDropDown = (key, collection) => ({
    collection,
    key,
    property: 'downtime',
    type: actions.UPDATE_CLAIM_ATTACHMENT_DOWN_TIME
});

export const updateAttachmentClaimFailedArea = value => ({
    property: 'failureArea',
    type: actions.UPDATE_CLAIM_ATTACHMENT_FAILED_AREA,
    value
});

export const updateAttachmentClaimFailedModeComments = value => ({
    property: 'failureModeComments',
    type: actions.UPDATE_CLAIM_ATTACHMENT_FAILED_MODE_COMMENTS,
    value
});

export const updateAttachmentClaimDtacCase = value => ({
    property: 'dtacCase',
    type: actions.UPDATE_CLAIM_ATTACHMENT_DTAC_CASE,
    value
});

export const updateAttachmentClaimDtacSolution = value => ({
    property: 'dtacSolution',
    type: actions.UPDATE_CLAIM_ATTACHMENT_DTAC_SOLUTION,
    value
});

export const updateAttachmentClaimOperatorsComplaint = value => ({
    property: 'operatorsComplaint',
    type: actions.UPDATE_CLAIM_ATTACHMENT_OPERATORS_COMPLAINT,
    value
});

export const updateAttachmentClaimComplaintCause = value => ({
    property: 'causeOfComplaining',
    type: actions.UPDATE_CLAIM_ATTACHMENT_COMPLAINT_CAUSE,
    value
});

export const updateAttachmentClaimComplaintCorrection = value => ({
    property: 'howWasComplaintCorrected',
    type: actions.UPDATE_CLAIM_ATTACHMENT_COMPLAINT_CORRECTION,
    value
});

export const updateAttachmentClaimOperatorComments = value => ({
    property: 'comments',
    type: actions.UPDATE_CLAIM_ATTACHMENT_OPERATORS_COMMENTS,
    value
});

export const updateAttachmentClaimBasisForSettlement = value => ({
    property: 'basisForSettlement',
    type: actions.UPDATE_CLAIM_ATTACHMENT_BASIS_FOR_SETTLEMENT,
    value
});



// WEBPACK FOOTER //
// ./src/claim/attachment/action-creators/failure-panel.js